import { IUserSubprofileModel } from "../models";

const cleanUp = (initialHomePage?: string): string | undefined =>
  initialHomePage?.replace("/", "");

const findCurrentProfile = (profiles?: IUserSubprofileModel[]) =>
  profiles?.find((profile) => profile.CurrentProfile);

const findMainProfile = (profiles?: IUserSubprofileModel[]) =>
  profiles?.find((profile) => profile.Owner);

const sortSubProfiles = (profiles: IUserSubprofileModel[]) => {
  profiles.sort((a, b) => (a.Owner === b.Owner ? 0 : a.Owner ? -1 : 1));
};

/**
 * ProfileType is a comma-separated list of "country:rating" pairs
 * (e.g. "DK:0,DK:7"). The maximum allowed rating is the highest numeric
 * rating across all pairs, regardless of country.
 */
const getMaxAllowedParentalRating = (profileType?: string): number => {
  if (!profileType) {
    return 0;
  }

  let maxRating = 0;

  for (const entry of profileType.split(",")) {
    const [, rating] = entry.split(":");
    maxRating = Math.max(maxRating, Number.parseInt(rating, 10));
  }

  return maxRating;
};

export const userProfileHelper = {
  cleanUp,
  findCurrentProfile,
  findMainProfile,
  sortSubProfiles,
  getMaxAllowedParentalRating,
};
